export default __webpack_public_path__ + "static/media/check-new.84f17916.svg";